var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bind-di-wrapper"},[(_vm.computeExpress(_vm.rowMenu.showExp, _vm.parentVue.formData, true))?_c('div',{staticClass:"bind-btn",class:{
      'bind-btn--disabled': !_vm.computeExpress(_vm.rowMenu.enableExp, _vm.parentVue.formData, true),
    },on:{"click":_vm.handlerClick}},[_vm._v("\n    "+_vm._s(_vm.rowMenu.name)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }